import { AuthPlugin, AuthType } from '@microsoft/1ds-auth-js';
import { PropertiesPlugin } from '@microsoft/1ds-properties-js';
import { CorrelationVectorPlugin } from '@microsoft/1ds-cv-js';
import { QosPlugin } from '@microsoft/1ds-qos-js';
import { getWindow } from '@shared/services/window';
import { Constants, Environment, OneDSEnvs } from '@shared/utils/constants';
import * as appConfig from '@shared/services/init/appConfig';
import { getGPCValue } from '@shared/utils/privacyUtils';
const envsMap = {
    [Environment.Production]: OneDSEnvs.Production,
    [Environment.Canary]: OneDSEnvs.Canary,
    [Environment.Development]: OneDSEnvs.Internal,
    [Environment.Dogfood]: OneDSEnvs.Dogfood,
    [Environment.Test]: OneDSEnvs.Test
};
const getEnvName = ()=>{
    var _getWindow___INITIAL_STATE___config_siteEnvironment, _getWindow___INITIAL_STATE___config, _getWindow___INITIAL_STATE__, _getWindow, _process_env, _process;
    var _getWindow___INITIAL_STATE___config_siteEnvironment_toLowerCase;
    const siteEnvironment = (_getWindow___INITIAL_STATE___config_siteEnvironment_toLowerCase = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow___INITIAL_STATE__ = _getWindow.__INITIAL_STATE__) === null || _getWindow___INITIAL_STATE__ === void 0 ? void 0 : (_getWindow___INITIAL_STATE___config = _getWindow___INITIAL_STATE__.config) === null || _getWindow___INITIAL_STATE___config === void 0 ? void 0 : (_getWindow___INITIAL_STATE___config_siteEnvironment = _getWindow___INITIAL_STATE___config.siteEnvironment) === null || _getWindow___INITIAL_STATE___config_siteEnvironment === void 0 ? void 0 : _getWindow___INITIAL_STATE___config_siteEnvironment.toLowerCase()) !== null && _getWindow___INITIAL_STATE___config_siteEnvironment_toLowerCase !== void 0 ? _getWindow___INITIAL_STATE___config_siteEnvironment_toLowerCase : (_process = process) === null || _process === void 0 ? void 0 : (_process_env = _process.env) === null || _process_env === void 0 ? void 0 : _process_env.siteEnvironment;
    const env = envsMap[`${siteEnvironment}`];
    if (!env) {
        throw new Error('failed to load env name for telemetry');
    }
    return env;
};
const authPlugin = new AuthPlugin();
const propertiesPlugin = new PropertiesPlugin();
const cvPlugin = new CorrelationVectorPlugin();
const qosPlugin = new QosPlugin();
const webAnalyticsConfig = {
    urlCollectQuery: true,
    urlCollectHash: true,
    autoCapture: {
        scroll: true,
        pageView: true,
        onLoad: true,
        onUnload: true,
        click: true,
        resize: true,
        lineage: true,
        jsError: true
    },
    shareAuthStatus: true,
    callback: {
        signedinStatus: ()=>{
            var _getWindow___INITIAL_STATE___users, _getWindow___INITIAL_STATE__, _getWindow;
            var _getWindow___INITIAL_STATE___users_signedIn;
            return (_getWindow___INITIAL_STATE___users_signedIn = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow___INITIAL_STATE__ = _getWindow.__INITIAL_STATE__) === null || _getWindow___INITIAL_STATE__ === void 0 ? void 0 : (_getWindow___INITIAL_STATE___users = _getWindow___INITIAL_STATE__.users) === null || _getWindow___INITIAL_STATE___users === void 0 ? void 0 : _getWindow___INITIAL_STATE___users.signedIn) !== null && _getWindow___INITIAL_STATE___users_signedIn !== void 0 ? _getWindow___INITIAL_STATE___users_signedIn : false;
        }
    }
};
const authConfig = {
    authType: AuthType.AAD,
    loggedInStatusCallback: ()=>{
        var _getWindow___INITIAL_STATE___users, _getWindow___INITIAL_STATE__, _getWindow;
        var _getWindow___INITIAL_STATE___users_signedIn;
        return (_getWindow___INITIAL_STATE___users_signedIn = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow___INITIAL_STATE__ = _getWindow.__INITIAL_STATE__) === null || _getWindow___INITIAL_STATE__ === void 0 ? void 0 : (_getWindow___INITIAL_STATE___users = _getWindow___INITIAL_STATE__.users) === null || _getWindow___INITIAL_STATE___users === void 0 ? void 0 : _getWindow___INITIAL_STATE___users.signedIn) !== null && _getWindow___INITIAL_STATE___users_signedIn !== void 0 ? _getWindow___INITIAL_STATE___users_signedIn : false;
    }
};
const propertiesPluginConfig = ()=>{
    var _getGPCValue;
    return {
        populateBrowserInfo: true,
        populateOperatingSystemInfo: true,
        enableApplicationInsightsTrace: true,
        enableApplicationInsightsUser: true,
        userConsentCookieName: Constants.Cookies.privacyConsentAcceptedDate,
        env: getEnvName(),
        // eslint-disable-next-line camelcase
        gpcDataSharingOptIn: (_getGPCValue = getGPCValue()) !== null && _getGPCValue !== void 0 ? _getGPCValue : true,
        callback: {
            userConsentDetails: ()=>appConfig.get('siteConsent')
        }
    };
};
const qosConfig = ()=>{
    var _getWindow;
    return {
        disableAjaxTracking: false,
        disableFetchTracking: false,
        maxAjaxCallsPerView: -1,
        excludeRequestFromAutoTrackingPatterns: [
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.__INITIAL_STATE__.config.telemetryEndpoint.toLowerCase()
        ]
    };
};
export const config = ()=>{
    var _getWindow, _getWindow1;
    return {
        propertyConfiguration: propertiesPluginConfig(),
        instrumentationKey: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.__INITIAL_STATE__.config.loggingInstrumentationKey,
        endpointUrl: (_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : _getWindow1.__INITIAL_STATE__.config.telemetryEndpoint,
        webAnalyticsConfiguration: webAnalyticsConfig,
        extensions: [
            authPlugin,
            propertiesPlugin,
            cvPlugin,
            qosPlugin
        ],
        extensionConfig: {
            [authPlugin.identifier]: authConfig,
            [propertiesPlugin.identifier]: propertiesPluginConfig(),
            [qosPlugin.identifier]: qosConfig()
        },
        perfEvtsSendAll: true
    };
};
